import { boot } from 'quasar/wrappers';
import * as Sentry from '@sentry/vue';

export default boot(({ app }) => {
  Sentry.init({
    app,
    dsn: 'https://ad11fe1ae1497ce8c8ef0f1df0b3ef54@o4508275708329984.ingest.de.sentry.io/4508275722354768',
    integrations: [],
  });
});
